import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";

const BioVizGallery = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px;
    gap: 40px;
    color: lightgray;
    text-align: justify;
`

const BioVizItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

const Screenshot = styled.img`
    border-radius: 1rem;
    width: 100%;
`

const Logo = styled.img`
    position: relative;
    top: 0.2rem;
    border-radius: 0.2rem;
    width: 6rem;
    padding: 0.1rem;
    background-color: #fbfbfb;
`

const Video = styled.iframe`
    width: 100%;
    aspect-ratio: 16 / 9;
    border: 0px;
    border-radius: 1rem;
`

const Me = styled.span`
    text-decoration: underline;
`

const Journal = styled.span`
    font-style: italic;
`

const Paper = styled.p`
    a{
        text-decoration: underline;
    }
`

const Divider = styled.div`
    border-bottom: 1px grey solid;
`

const DividerShort = styled.div`
    width: 400px;
    border-bottom: 1px grey solid;
`
const Intro = styled.div`
    a{
        text-decoration: underline;
    }
`



const Paragraph = styled.p`
    margin-bottom: 16px;
`
export default function BioViz() {
    useTranslation();

    return <BioVizGallery>
        <BioVizItem>
            <Intro>
                <Trans i18nKey="bioviz.intro">
                    I'm a researcher with a <strong>background in computer science</strong>. I specialize in creating <strong>usable biochemical visualizations</strong>. Currently working on my PhD at</Trans> <a href="https://visitlab.fi.muni.cz/"><Logo src="https://i.imgur.com/boQmbHH.png" alt="visitlab" /></a> <Trans i18nKey="bioviz.introcont">(Masaryk University, Brno, Czech Republic) under the supervision of doc. Barbora Kozlíková, PhD.</Trans>
            </Intro>
        </BioVizItem>
        <Divider />

        <BioVizItem>
            <Screenshot src="https://i.imgur.com/XeNXFrW.png" />
            <Intro>
                <Paragraph>
                    <strong>LoopGrafter</strong> is intended to provide guidance on transplanting loops between two structurally related proteins while allowing users to visually assess their dynamic properties. In collaboration with Loschmidt Laboratories, I designed the set of visualizations used in this software and led the development of both the frontend and the backend.
                </Paragraph>

                <Paragraph>
                    Available here: <a href="https://loschmidt.chemi.muni.cz/loopgrafter/#/">https://loschmidt.chemi.muni.cz/loopgrafter/#/</a>
                </Paragraph>
            </Intro>
            <Paper>Joan Planas-Iglesias*, <Me>Filip Opaleny*</Me>, Pavol Ulbrich, Jan Stourac, Zainab Sanusi, Gaspar P Pinto, Andrea Schenkmayerova, Jan Byska, Jiri Damborsky, Barbora Kozlikova, David Bednar, LoopGrafter: a web tool for transplanting dynamical loops for protein engineering, <Journal>Nucleic Acids Research</Journal>, 2022 (<a href="https://doi.org/10.1093/nar/gkac249">https://doi.org/10.1093/nar/gkac249</a>)
            </Paper>
            <p>*The authors wish it to be known that, in their opinion, the first two authors should be regarded as Joint First Authors.</p>
            <DividerShort />
            <Paper><Me>Filip Opaleny</Me>, Pavol Ulbrich, Joan Planas-Iglesias, Jan Byska, Gaspar P Pinto, David Bednar, Katarina Furmanova, Barbora Kozlikova, Visual Support for the Grafting Workflow of Protein Loops <Journal>(in preparation)</Journal></Paper>

        </BioVizItem>
        <Divider />
        <BioVizItem>
            <Video src="https://www.youtube-nocookie.com/embed/UKb0esf2a2U" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></Video>
            <Intro>
                <Paragraph>
                    <strong>ChromoSkein</strong> is a web-based tool for visualizing three-dimensional chromatin models. In collaboration with domain scientists from Icahn School of Medicine at Mount Sinai, New York, we designed visualization and interaction methods suitable for chromatin datasets as a frontend-only application running in the browser.
                </Paragraph>
                <Paragraph>
                    Available here: <a href="https://visitlab.pages.fi.muni.cz/chromatin/chromoskein/">https://visitlab.pages.fi.muni.cz/chromatin/chromoskein/</a>
                </Paragraph>
            </Intro>
            <Paper>Matúš Talčík, <Me>Filip Opálený</Me>, Tereza Clarence, Katarína Furmanová, Jan Byška, Barbora Kozlíková, David Kouřil, ChromoSkein: Untangling Three-Dimensional Chromatin Fiber With a Web-Based Visualization Framework <Journal>(in preparation, preprint <a href="https://arxiv.org/abs/2211.05125">here</a>)</Journal></Paper>
        </BioVizItem>
        <Divider />
        <BioVizItem>
            <Screenshot src="https://i.imgur.com/3k32ljE.png" />
            <Intro>
                <strong>Chrom-o-graph</strong> is an interactive tool for the visualization of three-dimensional genomic datasets. We use force-directed graph algorithms to flatten the dataset into two dimensions while preserving spatial information. It is currently under development as a frontend-only application running in the browser.
            </Intro>
            <Paragraph><Me>Filip Opálený</Me>, et. al <Journal>(in preparation)</Journal></Paragraph>
        </BioVizItem>
    </BioVizGallery>
}